import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { faCalendarPlus, faFileLines } from "@fortawesome/pro-regular-svg-icons";
import { SYNC_LIFECYCLE_COMPLETE, SYNC_LIFECYCLE_FAILED, SYNC_STATUS_INDEX, SYNC_STATUS_INTENT, SYNC_STATUS_LABEL } from "./sync-constants";
var RESOURCE_LABEL = {
  Encounter: {
    key: "encounter",
    fallback: "Encounter",
    icon: faCalendarPlus
  },
  DocumentReference: {
    key: "attachment",
    fallback: "Attachment",
    icon: faFileLines
  }
};
var VERB_FALLBACK = {
  create: "Create",
  update: "Update"
};

/** Returns the semantic intent for a sync status. */
export function getSyncStatusIntent(status) {
  var _SYNC_STATUS_INTENT$s;
  return (_SYNC_STATUS_INTENT$s = SYNC_STATUS_INTENT[status.toLowerCase()]) !== null && _SYNC_STATUS_INTENT$s !== void 0 ? _SYNC_STATUS_INTENT$s : "base";
}

/** Returns the human-readable label for a sync status. */
export function getSyncStatusLabel(status) {
  var _SYNC_STATUS_LABEL$st;
  return (_SYNC_STATUS_LABEL$st = SYNC_STATUS_LABEL[status.toLowerCase()]) !== null && _SYNC_STATUS_LABEL$st !== void 0 ? _SYNC_STATUS_LABEL$st : status;
}

/** Returns the icon and translation descriptor for a sync action (e.g. 'Create Encounter'). */
export function getSyncActionMeta(item) {
  var _RESOURCE_LABEL$item$, _VERB_FALLBACK$item$a;
  var resource = (_RESOURCE_LABEL$item$ = RESOURCE_LABEL[item.resource_type]) !== null && _RESOURCE_LABEL$item$ !== void 0 ? _RESOURCE_LABEL$item$ : {
    key: "resource",
    fallback: item.resource_type,
    icon: faCalendarPlus
  };
  var verb = (_VERB_FALLBACK$item$a = VERB_FALLBACK[item.action]) !== null && _VERB_FALLBACK$item$a !== void 0 ? _VERB_FALLBACK$item$a : item.action;
  return {
    labelKey: "".concat(item.action, "_").concat(resource.key),
    fallback: "".concat(verb, " ").concat(resource.fallback),
    icon: resource.icon
  };
}

/** Returns the target encounter descriptor for a submission, or null when unassigned. */
export function getSyncTarget(item) {
  var _item$meta, _item$meta2, _item$meta3;
  var id = ((_item$meta = item.meta) === null || _item$meta === void 0 ? void 0 : _item$meta.encounter_fhir_id) || item.fhir_resource_id || item.outbound_ref_id;
  var type = (_item$meta2 = item.meta) === null || _item$meta2 === void 0 ? void 0 : _item$meta2.encounter_type;
  var start = (_item$meta3 = item.meta) === null || _item$meta3 === void 0 ? void 0 : _item$meta3.encounter_start;
  if (!id && !type && !start) return null;
  return {
    id: id !== null && id !== void 0 ? id : "",
    type: type,
    start: start
  };
}

/** Returns the ordered lifecycle stage labels for a submission. */
export function getLifecycleStages(item) {
  var status = item.status.toLowerCase();
  if (status === "failed") return _toConsumableArray(SYNC_LIFECYCLE_FAILED);
  var endIndex = SYNC_STATUS_INDEX[status];
  if (endIndex !== undefined) return SYNC_LIFECYCLE_COMPLETE.slice(0, endIndex + 1);
  return [SYNC_LIFECYCLE_COMPLETE[0]];
}